import { createAsyncThunk } from "@reduxjs/toolkit";
import classesService from "../../../api/services/classes";

export const fetchEvents = createAsyncThunk(
  "events/fetchEvents",
  async (requestData) => await classesService.fetchEvents(requestData)
);
